import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LogService } from 'src/app/core/services/log/log.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { ActivitePrestation } from 'src/app/shared/models/activitePrestation';
import {
	AbstractControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { Observable, of, Subscriber } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { User } from 'src/app/shared/models/security/user';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ModaliteReunion } from 'src/app/shared/models/modaliteReunion';
import { TypeEntretien } from 'src/app/shared/models/typeEntretien';
import { Prestation } from 'src/app/shared/models/prestation';
import { Tache } from 'src/app/shared/models/tache';
import { Options } from '@angular-slider/ngx-slider';
import { Router } from '@angular/router';

@Component({
	selector: 'app-activitePrestation-form',
	templateUrl: './activitePrestation-form.component.html',
	styleUrls: ['./activitePrestation-form.component.scss']
})
export class ActivitePrestationFormComponent implements OnInit {
	@Input() activitePrestation: ActivitePrestation;
	@Input() prestation: Prestation;
	@Input() isAddForm: boolean;
	@Input() isAddressSelected: { value: boolean };
	@Input() isAddressDefault: { value: boolean };
	@Input() isAddressStructureSelected: { value: boolean };
	@Input() isAddressStructureDefault: { value: boolean };
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	@Input() isValidateButtonClicked: { value: boolean };
	@Input() form: FormGroup;
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();


	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[a-zA-z'éèàç.-_]+( [a-zA-z'éèàç.-_]+)*$");

	activitePrestations: ActivitePrestation[] = null;

	labelIntervenantCapitalized: string;

	selectedaddress?: Address;
	selectedaddressStructure?: Address;
	typeaheadLoading?: boolean;
	addressList: Observable<NominatimResponse[]>;
	addressStructureList: Observable<NominatimResponse[]>;
	searchResults: NominatimResponse[];

	listModaliteReunion: ModaliteReunion[];
	listTache: Tache[];
	listIntervenant: Employee[];
	listActivite: ActivitePrestation[];

	isPreferencesActive = false;

	user: User;

	constructor(private logger: LogService, private facade: FacadeService, private router: Router) {
	
	}

	ngOnInit(): void {
		if (this.activitePrestation) {

			this.labelIntervenantCapitalized =
				this.facade.dataStorageService.getLabelCapitalized(
					PARAM_LABEL_INTERVENANT
				);
			this.user = this.facade.dataStorageService.getUser();

			this.isPreferencesActive =
				this.facade.dataStorageService.isPreferencesBeneficiaireActive();

			this.facade.tacheService.getAllTache().subscribe({
				next: (val) => {
					this.listTache = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.employeeService.getAllActiveEmployees().subscribe({
				next: (val) => {
					this.listIntervenant = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.facade.modaliteReunionService.getAllModaliteReunion().subscribe({
				next: (val) => {
					this.listModaliteReunion = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			const prestationId = +this.router.url.split('/').pop();
			this.facade.prestationService
			.getPrestationById(prestationId)
			.subscribe((prestation: Prestation) => {
				this.prestation = prestation;
			});

			this.facade.activitePrestationService.getByPrestation(this.prestation.id).subscribe({
				next: (val) => {
					this.listActivite = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			// Deep copy
			//this.listSelectedIntervenant = [...this.activitePrestation.intervenants];

			if (!this.isAddForm) {
				this.form.patchValue({
					description: this.activitePrestation.description,
					intervenant: this.activitePrestation.intervenant?.id,
					tache: this.activitePrestation.tache?.id,
					chargeTravail: this.activitePrestation.chargeTravail,
					modaliteReunion: this.activitePrestation.modaliteReunion?.id,
				});
			} 

		}
	}

	// ngOnChanges(): void {
	// 	// this.mapUnavailabilities();
	// }

	submitForm() {
		if (
			this.form.valid &&
			(this.isAddressSelected.value || this.isAddressDefault.value)
		) {
			this.isValidateButtonClicked.value = true;
			this.activitePrestation.tache = this.listTache.find(x => x.id == this.form.get('tache').value);
			this.activitePrestation.chargeTravail = this.form.get('chargeTravail').value;
			this.activitePrestation.modaliteReunion = this.listModaliteReunion.find(x => x.id == this.form.get('modaliteReunion').value);
			this.activitePrestation.intervenant = this.listIntervenant.find(x => x.id == this.form.get('intervenant').value);
			this.activitePrestation.description = this.form.get('description').value;

			this.sendForm.emit();
		} else {
			// this.facade.toastService.createErrorToast();
			this.isValidateButtonClicked.value = false;
		}
	}

	get intervenant() {
		return this.form.get('intervenant');
	}
	get tache() {
		return this.form.get('tache');
	}
	get chargeTravail() {
		return this.form.get('chargeTravail');
	}
	get modaliteReunion() {
		return this.form.get('modaliteReunion');
	}
	get description() {
		return this.form.get('description');
	}

	
}
